import createIcon from '../../createIcon';

/**
 * @component @name VolumeDown
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNzUgMTJDMTguNzUgMTAuMjMgMTcuNzMgOC43MSAxNi4yNSA3Ljk3VjE2LjAyQzE3LjczIDE1LjI5IDE4Ljc1IDEzLjc3IDE4Ljc1IDEyWk01LjI1IDlWMTVIOS4yNUwxNC4yNSAyMFY0TDkuMjUgOUg1LjI1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const VolumeDown = createIcon('VolumeDown', [
  [
    'path',
    {
      d: 'M18.75 12C18.75 10.23 17.73 8.71 16.25 7.97V16.02C17.73 15.29 18.75 13.77 18.75 12ZM5.25 9V15H9.25L14.25 20V4L9.25 9H5.25Z',
      key: '5220el',
    },
  ],
]);

export default VolumeDown;
